/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/race_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./race_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RaceServiceClient =
  function RaceServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RaceServicePromiseClient =
  function RaceServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRacesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRacesResponse>}
 */
const methodDescriptor_RaceService_ListRace = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.RaceService/ListRace",
  grpc.web.MethodType.UNARY,
  stronachgroup_first_racehorse360_messages_pb.ListRacesRequest,
  stronachgroup_first_racehorse360_messages_pb.ListRacesResponse,
  /**
   * @param {!proto.stronachgroup.first.racehorse360.ListRacesRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.constructor.encode(request).finish();
  },
  stronachgroup_first_racehorse360_messages_pb.ListRacesResponse.decode
);

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRacesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRacesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRacesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceServiceClient.prototype.listRace =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.RaceService/ListRace",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRace,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRacesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRacesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceServicePromiseClient.prototype.listRace =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + "/stronachgroup.first.racehorse360.RaceService/ListRace",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRace
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRaceHistoriesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRaceHistoriesResponse>}
 */
const methodDescriptor_RaceService_ListRaceHistories =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceService/ListRaceHistories",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListRaceHistoriesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListRaceHistoriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListRaceHistoriesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListRaceHistoriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRaceHistoriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRaceHistoriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRaceHistoriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceServiceClient.prototype.listRaceHistories =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListRaceHistories",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRaceHistories,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRaceHistoriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRaceHistoriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceServicePromiseClient.prototype.listRaceHistories =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListRaceHistories",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRaceHistories
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse>}
 */
const methodDescriptor_RaceService_ListRaceRestrictions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceService/ListRaceRestrictions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListRaceRestrictionsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListRaceRestrictionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListRaceRestrictionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceServiceClient.prototype.listRaceRestrictions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListRaceRestrictions",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRaceRestrictions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceServicePromiseClient.prototype.listRaceRestrictions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListRaceRestrictions",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListRaceRestrictions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRacesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListUpcomingRacesResponse>}
 */
const methodDescriptor_RaceService_ListUpcomingRaces =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceService/ListUpcomingRaces",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRacesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRacesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRacesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListUpcomingRacesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRacesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListUpcomingRacesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListUpcomingRacesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceServiceClient.prototype.listUpcomingRaces =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListUpcomingRaces",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListUpcomingRaces,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListUpcomingRacesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListUpcomingRacesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceServicePromiseClient.prototype.listUpcomingRaces =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListUpcomingRaces",
      request,
      metadata || {},
      methodDescriptor_RaceService_ListUpcomingRaces
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
